import router from './router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import * as apiAuth from '@/api/auth'

NProgress.configure({ showSpinner: false })// NProgress Configuration

const whiteList = ['/login']// no redirect whitelist

router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar
  apiAuth.get()
    .then(res => {
      if (to.path === '/login') {
        next({path: '/'})
        NProgress.done()
      } else {
        next()
      }
    })
    .catch(() => {
      if (whiteList.indexOf(to.path) !== -1) {
        next()
      } else {
        next({path: '/login'})
        NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
      }
    })
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})



// WEBPACK FOOTER //
// ./src/permission.js